export const preferredProgramAccessibilityLabel = 'Service Level Agreement';

export const preferredProgramTooltipHeading = 'Preferred Program';

export const preferredProgramTooltipContent = () => {
  return `<p>
      This icon indicates a <strong>Preferred Program</strong>. <strong>Preferred Programs</strong> have faster admissions processes and enhanced academic support. Learn more <a target="_blank" href="/into-us-service-levels">here</a>
    </p>`;
};
